import styled from 'styled-components';
import React, { useState , useEffect, useContext} from 'react';
import { useSpring, animated } from 'react-spring';
import axios from 'axios';
import { PredContext } from './sportsc/predContext';
import { PriceContext } from './context';


const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr); /* Matching your 7-column layout */
  gap: 15px;
  width: 100%;
  padding: 0 24px; /* Matches ArticleContainer padding */
  position: sticky;
  top: 0;
  background-color: #f8fafc;
  z-index: 10;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 10px;
`;

const HeaderCell = styled.div`
  font-weight: 700;
  font-size: 0.8rem;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px 0;
  text-align: center;
`;
// Main container that wraps the entire article, designed for a full-screen display.
// It uses styles to replicate the Tailwind classes from the original HTML.
const ArticleContainer = styled(animated.div)`
  position: relative;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 15px; 

  /* 1. Change width and max-width to fit the parent */
  width: 100%;
  max-width: 100%; 
  
  /* 2. REMOVE min-height: 80vh and use a fixed height or auto */
  height: auto;
  max-height: 600px; /* Or whatever height fits your parent constraint */
  
  /* 3. Enable scrolling so it doesn't bleed out of the parent */
  overflow-y: auto;
  overflow-x: hidden;

  margin: 0; 
  padding: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0; /* Optional: helps see the boundary */
  border-radius: 8px;
`;
const TeamSquare = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  aspect-ratio: 1 / 1;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Reduce font size if the numbers are small */
  font-size: 0.9rem;
  color: #0e141b;

  /* If the parent is tight, ensure the squares don't force a giant row */
  min-width: 0; 
`;
const ListItem = styled.li`
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: #ddd;
  }
  transition: background-color 1.3s ease;  /* Add this line for smooth hover effect */
`;

const SelectionList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
    color:black;

`;
// Styled component for the back arrow icon.
const BackArrowIcon = styled.div`
  color: #0e141b;
  display: flex;
  width: 3rem; /* size-12 */
  height: 3rem; /* size-12 */
  flex-shrink: 0;
  align-items: center;
`;

// Styled component for the main article heading.
const ArticleTitle = styled.h2`
  color: #0e141b;
  font-size: 1.125rem; /* text-lg */
  font-weight: 700; /* font-bold */
  line-height: 1.5; /* leading-tight */
  letter-spacing: -0.015em; /* tracking-[-0.015em] */
  flex: 1;
  text-align: center;
  padding-right: 3rem; /* pr-12 */
`;

// Another styled component for the main headline of the article.
const MainHeadline = styled.h2`
  color: #0e141b;
  letter-spacing: -0.025em; /* tracking-light */
  font-size: 1.75rem; /* text-[28px] */
  font-weight: 700; /* font-bold */
  line-height: 1.5; /* leading-tight */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 1.25rem; /* pt-5 */
  text-align: left;
`;

// A styled paragraph for the author and date.
const AuthorText = styled.p`
  color: #4e7397;
  font-size: 0.875rem; /* text-sm */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 0.25rem; /* pt-1 */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
`;

// A styled paragraph for the main body of the article.
const BodyText = styled.p`
  color: #0e141b;
  font-size: 1rem; /* text-base */
  font-weight: 400; /* font-normal */
  line-height: 1.5; /* leading-normal */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 0.25rem; /* pt-1 */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
`;

// The main React component that assembles all the styled components.
 function Article({teamData}) {
  console.log('raaaar')
  console.log(teamData)
  const headers = ["Points Pred", "Points Actual", "Assists Pred", "Assists Actual", "Rebounds Pred", "Rebounds Actual", "PLAYER"];
  
  return (
<ArticleContainer>
{headers.map((s, i) => (
    <TeamSquare key={`header-${i}`}>
      {s}
    </TeamSquare>
  ))}

  {teamData.data.map((playerRow, rowIndex) => (
    // We loop through the first 6 items of each player's array
    playerRow.slice(0, 7).map((stat, statIndex) => (
      <TeamSquare key={`${rowIndex}-${statIndex}`}>
        {stat}
      </TeamSquare>
    ))
  ))}
</ArticleContainer>
  );
}
const FullScreenOverlay = styled(animated.div)`
  position: fixed;
top: 0;
left: 0;
  width: 100%;
  height: 100vh;
  background-color: white; // Or any background color you prefer
  z-index: 100; // Ensure it's on top of other content
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
`;

function shortenValue(val) {
  // 1. If it's not a number, or it's a string that can't be converted to a number
  if (typeof val === 'string' && isNaN(val)) {
    return val;
  }

  // 2. If it's a number (or a numeric string), round to 2 decimal places
  // We use Number() to ensure numeric strings like "10.555" are treated as numbers
  return Number(val).toFixed(2);
}

const FullArticle = ({ onClose }) => {
    const [article, setOneArticle] = useState(null);
     const {teamData,  id} = useContext(PredContext);

    useEffect(() => {
        // Find the article whenever `teamData` or `id` changes
        const foundTeamData = teamData.find((art) => art.id === id);
        if (foundTeamData) {
            const cleanedArticle = {
                    ...foundTeamData, // 1. Copy the id and team name
                    data: foundTeamData.data.map(player => 
                        player.map(cell => shortenValue(cell)) // 2. Update only the nested array
                    )
};            setOneArticle(cleanedArticle);
        }
    }, [teamData, id]); // Correct dependency array

    const mountTransition = useSpring({
        from: { opacity: 0, transform: 'scale(0.8)' },
        to: { opacity: 1, transform: 'scale(1)' },
        config: { duration: 300 }
    });

    const unmountTransition = useSpring({
        from: { opacity: 1, transform: 'scale(1)' },
        to: { opacity: 0, transform: 'scale(0.8)' },
        config: { duration: 3000 },
        immediate: false
    });

    const props = onClose ? mountTransition : unmountTransition;
    return (
        <FullScreenOverlay style={props}>
            {/* Correct way to render a component with props */}
            {article && <Article teamData={article} />}
            <button onClick={onClose}>Close</button>
        </FullScreenOverlay>
    );
};


const SectionTitle = styled.h2`
  color: #0d141c;
  font-size: 1.375rem; /* text-[22px] */
  font-weight: bold;
  line-height: 1.25; /* leading-tight */
  letter-spacing: -0.015em;
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
  padding-bottom: 0.75rem; /* pb-3 */
  padding-top: 1.25rem; /* pt-5 */
`;

const GameAnalysisContainer = styled.div`
  display: flex;
  flex-direction: column; /* Stack items vertically */
  width: 100%; /* Take up the full viewport width */
  height: 100vh; /* Take up the full viewport height */
  overflow-y: auto; /* Enable vertical scrolling when content overflows */
  background-color: #f8fafc; /* Optional: Set a background color */
`;
const GameAnalysisContent = styled.div`
  display: flex;
  height:15%;
  flex-direction: column;
  justify-content: center;
`;

const GameAnalysisTitle = styled.p`
  color: #0e141b;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;

    display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* line-clamp-1 */
`;
const SubscriptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem; /* gap-4 */
  background-color: #f8fafc; /* bg-slate-50 */
  padding-left: 1rem; /* px-4 */
  padding-right: 1rem; /* px-4 */
  min-height: 4.5rem; /* min-h-[72px] */
  padding-top: 0.5rem; /* py-2 */
  padding-bottom: 0.5rem; /* py-2 */
`;
const GameAnalysisDescription = styled.p`
  color: #4e7397;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
`;
const IconContainer = styled.div`
  color: #0d141c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem; /* rounded-lg */
  background-color: #e7edf4;
  flex-shrink: 0;
  width: 3rem; /* size-12 */
  height: 3rem; /* size-12 */

  svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }
`;
const GameTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;


const GameAnalysisAuthor = styled.p`
  color: #4e7397;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
`;

function orderTeam(teamData, useFirstSwapMode = false) {
  let count = 0;
  let groups = {};

  for (let i = 0; i < teamData.length; i++) {
    // 1. Define the row FIRST
    let row = [...teamData[i]]; 
    let teamName;

    // 2. Check the ROW length (number of columns), not teamData.length
    // If it's the "Short Version" (length 8), team is at index 7
    // If it's the "Long Version" (length 11+), team is at index 10
    if (row.length <= 8) {
      teamName = row[7];
    } else {
      teamName = row[10];
    }

if (row.length < 10) {
      row[1] = 0;
      row[3] = 0;
      row[5] = 0;
      }


    // 3. Only perform swaps if the columns actually exist to avoid "undefined" values
    if (row.length > 8) {
      if (useFirstSwapMode) {
        [row[1], row[7]] = [row[7], row[1]];
        [row[3], row[8]] = [row[8], row[3]];
        [row[5], row[9]] = [row[9], row[5]]; // Fixed index 4 typo to 5
      } else {
        [row[0], row[1]] = [row[1], row[0]];
        [row[2], row[3]] = [row[3], row[2]];
        [row[4], row[5]] = [row[5], row[4]];
        
        // Secondary swap
        [row[1], row[7]] = [row[7], row[1]];
        [row[3], row[8]] = [row[8], row[3]];
        [row[5], row[9]] = [row[9], row[5]];
      }
    }

    // 4. Remove the last element (the .csv filename)
    const cleanRow = row.slice(0, -1);

    // 5. Grouping logic
    if (!groups[teamName]) {
      groups[teamName] = { 
        team: teamName, 
        data: [cleanRow], 
        id: count 
      };
      count++;
    } else {
      groups[teamName].data.push(cleanRow);
    }
  }

  return Object.values(groups);
}

function TeamData() {
      const [showFullArticle, setShowFullArticle] = useState(false);
    const {email} = useContext(PriceContext);
    const {teamData, setTeamData, setId, id} = useContext(PredContext);

  const predCheck = async () => {
  console.log('running check');
  
  try {
    const response = await axios({
      method: 'post',
      url: `https://w9jquav0ml.execute-api.us-east-2.amazonaws.com/pred_dev/pred/tpull`,
      withCredentials: false,
      data: {
        email: email,
        path: 'team-data'
      },
    });

    // If we reach here, the request was successful
    const res_data = response.data;
    const data = res_data.data
    console.log('team player pred data test load', data);
    const teamDataOrganized = orderTeam(data)

    const shortenedTeam = shortenValue(teamDataOrganized)
    console.log('data in good shappe',teamDataOrganized)
    setTeamData(teamDataOrganized);

  } catch (error) {
    // This will catch network errors, 4xx/5xx responses, 
    // and any errors thrown in the try block above.
    console.error('Error fetching team data:', error.message);
    
    // Optional: Handle specific error types
    if (error.response) {
      console.log('Server responded with:', error.response.status);
    }
  }
};



    
      
useEffect(() => {
  console.log('use effect started ')
        predCheck()
    }, [])
  const handleTitleClick = () => {
    setShowFullArticle(true);
  };

  const handleClose = () => {
    setShowFullArticle(false);
  };
  console.log('final team Dataq', teamData)
  return (
    <GameAnalysisContainer>
              {showFullArticle && <FullArticle onClose={handleClose} />}
          <SectionTitle>Team predictions</SectionTitle>
{teamData.map((team) => (
  <SubscriptionItem key={team.id}>
                <IconContainer>
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                <path
                  d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,112h-8a32,32,0,0,1,0-64h8ZM32,96h8a32,32,0,0,1,0,64H32Zm0,80h8a48,48,0,0,0,0-96H32V64h88V192H32Zm192,16H136V64h88V80h-8a48,48,0,0,0,0,96h8v16Z"
                ></path>
              </svg>
            </IconContainer>
            <GameTextContainer>
    <GameAnalysisTitle
      onClick={() => {
        handleTitleClick();
        setId(team.id);
        setTimeout(() => {
  // Your code to be executed after the timeout
  console.log("This message will appear after 1.5 seconds.");
}, 1);
      }}
    >
      {team.team}
    </GameAnalysisTitle>
    </GameTextContainer>
    {/* <GameAnalysisDescription>{article.description}</GameAnalysisDescription>
    <GameAnalysisAuthor>{article.published_date}</GameAnalysisAuthor> */}
  </SubscriptionItem>
))}
    </GameAnalysisContainer>
  );
}

export default TeamData;